import memoize from "memoize-one";
import { isMobile } from "./utils";

const makeWebStyles = memoize((styles: any): any => {
  if (!isMobile.any()) {
    return styles;
  }

  return {};
});

const makeConditionalStyles = memoize(
  (styles: React.CSSProperties, conditional: boolean): any => {
    if (conditional) {
      return styles;
    }

    return {};
  }
);

const defaultShadowStyles = Object.freeze({
  shadowOffset: { width: 0, height: 1 },
  shadowOpacity: 0.1,
  shadowRadius: 5,
  shadowColor: "#000",
  elevation: 4,
});

export { defaultShadowStyles, makeWebStyles, makeConditionalStyles };
